import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {Image} from '../../../atoms/Image/Image';
import {Heading16} from '../../../atoms/Text';
import {Text} from '../../../atoms/Text/Text';

const CardContainer = styled.div`
  padding: 20px;
  background: ${COLORS.White};
  box-shadow: 2px 8px 20px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.05);
`;

const TopRow = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  cursor: ${({onClick}) => (onClick ? 'pointer' : 'unset')};
`;

const CardIcon = styled.div`
  margin-right: 14px;
  width: 35px;
  height: 35px;
`;

const Content = styled.div<{$noSideMargins?: boolean}>`
  flex: 1;
  margin-top: 8px;
  ${({$noSideMargins}) =>
    !$noSideMargins && 'margin-left: 50px; margin-right: 30px;'}
`;

interface HelpCenterCardProps {
  arrowIcon?: React.ReactNode;
  title: string;
  iconUrl?: string;
  onTitleClick?: () => void;
  dataTestId?: string;
  noSideMargins?: boolean;
}

export const HelpCenterCard: FC<
  React.PropsWithChildren<HelpCenterCardProps>
> = ({
  arrowIcon,
  title,
  iconUrl,
  children,
  onTitleClick,
  dataTestId,
  noSideMargins,
}) => {
  return (
    <CardContainer data-testid={dataTestId || 'HelpCenterCard'}>
      <TopRow onClick={onTitleClick}>
        {iconUrl != null && (
          <CardIcon>
            <Image breakpoints={[]} ratio="1:1" src={iconUrl} />
          </CardIcon>
        )}
        <Heading16 style={{flex: 1, fontWeight: 'bold'}}>{title}</Heading16>
        {arrowIcon}
      </TopRow>
      {children && (
        <Content $noSideMargins={noSideMargins}>
          <Text size="px12" color="Grey1" weight="w400">
            {children}
          </Text>
        </Content>
      )}
    </CardContainer>
  );
};
